import Skeleton from "react-loading-skeleton";

// Hooks
import { useBreakpoint } from "hooks/useBreakpoint";

import "./styles.sass";

const SkeletonInviteTable = () => {
  const { isDesktop } = useBreakpoint();

  return isDesktop ? (
    <div className="SkeletonInviteTable">
      <div className="SkeletonInviteTable__title">
        <Skeleton width={730} height={22} borderRadius={4} />
      </div>
      <div className="SkeletonInviteTable__subtitle">
        <Skeleton width={730} height={219} />
      </div>
      <div className="SkeletonInviteTable-desc">
        <span>
          {" "}
          <Skeleton width={132} height={32} borderRadius={4} />{" "}
        </span>
        <span className="SkeletonInviteTable-desc__left">
          <span>
            <Skeleton width={32} height={32} borderRadius={4} />
          </span>
        </span>
        <span className="SkeletonInviteTable-desc__right">
          <span>
            <Skeleton width={32} height={32} borderRadius={4} />
          </span>
        </span>
      </div>
    </div>
  ) : (
    <div className="SkeletonInviteTable-mobile">
      <Skeleton width="100%" height={21} borderRadius={4} />
      <div className="SkeletonInviteTable-mobile__header">
        <Skeleton width="100%" height={219} borderRadius={4} />
      </div>
      <span className="SkeletonInviteTable-mobile-paginator">
        <span className="SkeletonInviteTable-mobile-paginator__arrow">
          <Skeleton width={120} height={36} borderRadius={4} />
        </span>
        <span className="SkeletonInviteTable-mobile-paginator__arrow">
          <Skeleton width={60} height={36} borderRadius={4} />
        </span>
        <span className="SkeletonInviteTable-mobile-paginator__arrow">
          <Skeleton width={120} height={36} borderRadius={4} />
        </span>
      </span>
    </div>
  );
};

export default SkeletonInviteTable;
